enum CardUsageLimitType {
  ECOM = 'ECOM',
}

export default CardUsageLimitType;
